<!-- 课程管理 添加 -->
<template>
  <div>
    <div class="form_box__group__item">
      <div class="form_box__group__item__title">上课地址:</div>
      <div class="form_box__group__item__content ml-10">
        <el-input v-model="location" placeholder="例如：上海市静安区南京西路595号上海棋院" style="width:600px;" @change="onAddressChanged"></el-input>
        <el-button type="primary" class="ml-2" @click="confirmAddress" @keyup.enter="confirmAddress">搜索确认</el-button>
      </div>
      <div class="form_box__group__item__tool"></div>
    </div>
    <div class="form_box__group__item">
      <div>
        <a href="https://lbs.qq.com/getPoint/" target="_blank" style="margin-top: 10px; margin-bottom: 20px; margin-left: 10px;">通过腾讯地图工具</a>
        <div class="w-60 ml-2" style="margin-top: 10px;">
          <el-alert title="请确认地图中“蓝色角标”的位置，蓝色角标可以拖拽(先单击，后拖拽) " type="warning"></el-alert>
        </div>
      </div>
    </div>

    <div class="map__container">
      <div id="container"></div>
      <div class="dimension">
        <div>经度:{{ lng }}</div>
        <div>纬度:{{ lat }}</div>
        <!-- {{mapAddress}} -->
      </div>
    </div>
  </div>
</template>


<script>
import { geoSearchApi } from "@/api/module/geo"

let QMap = null;
let QTool = null;
let QMarker = null;
let QGeometryEditor = null;

export default {
  name: "locationSelectorBaidu",
  data() {
    return {
      hasInitScript: false,
      location : "",
      lat : 0.0,
      lng : 0.0,
      mapGl: null,
      mapMarker: null,
      myGeo : null,
      mapAddress : "",
      mapaddresses : [],
      mapVal : [],
      loading : false,
      hasInit : false,
      point : null,
      index: -1

    };
  },
  methods:{
    init(){
      this.location = "";
      this.initMap();
      this.lng = 0
      this.lat = 0
    },

    initMap() {
      let _this = this;
      console.log("初始化地图")
      // 初始化 map

      if(QMap != null){
          console.log("地图已存在 销毁地图")
          QMap.destroy();
          QMap = null;

          QMarker = null;
          QGeometryEditor = null;
      }

      //定义地图中心点坐标
      var center = new TMap.LatLng(31.233858,121.471839)
      //定义map变量，调用 TMap.Map() 构造函数创建地图
      QMap = new TMap.Map(document.getElementById('container'), {
          zoom: 17.2,   //设置地图缩放级别
          pitch: 13.5,  //设置俯仰角
          rotation: 45    //设置地图旋转角度
      });

      QMap.setCenter(center);

      QMarker = new TMap.MultiMarker({
          id: "marker-layer22", //图层id
          map: QMap,
          styles: { //点标注的相关样式
              "marker": new TMap.MarkerStyle({
                  "width": 27,
                  "height": 33,
                  "anchor": { x: 16, y: 32 },
                  "src": "/assets/img/marker.png"
              })
          },
          geometries:[]
      });


      this.addPointerAndFocus(center.lng, center.lat);

       // 初始化几何图形及编辑器
      QGeometryEditor= new TMap.tools.GeometryEditor({
        map: QMap, // 编辑器绑定的地图对象
        overlayList: [{
          overlay: QMarker, // 可编辑图层
          id: "marker",
          selectedStyleId: "highlight"  // 被选中的marker会变为高亮样式
        }],
        actionMode: TMap.tools.constants.EDITOR_ACTION.INTERACT, // 编辑器的工作模式
        activeOverlayId: "marker", // 激活图层
        selectable: true
      });

      QGeometryEditor.on("adjust_complete", (val)=>{
        console.log("QGeometryEditor adjust_complete",val)

        // 更新位置
        this.lng = val.position.lng;
        this.lat = val.position.lat;
        _this.emitDatas();

      });


      console.log("初始化地图 结束")
    },


    emitDatas() {

      // QMarker
      console.log("emitDatas",QMarker)

      // 更新 lng / lat
      let addressData = {
        lat: this.lat,
        lng: this.lng,
        location: this.location,
      };
      this.$emit("onAddressChanged", addressData,this.index);

    },

    initLocation(lng, lat,index,address){
      console.log("initLocation",lng,lat)
      this.addPointerAndFocus(lng, lat);

      this.lng = lng;
      this.lat = lat;
      this.location = address;
      this.index = index;

    },

    onAddressChanged(){
      this.emitDatas();
    },


    confirmAddress(){ 
      this.searchLocation();
    },

    showInfoM(e) {
      this.lat = e.lnglat.lat;
      this.lng = e.lnglat.lng;
    },

    handleSelectLocation(item) {
      this.lat = item.lat;
      this.lng = item.lng;
      this.updateBMap(this.lng, this.lat);
    },

    antiShake(fun, tim) {
      let timeout = null;
      let _this = this;
      return function () {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          fun.call(_this, arguments);
        }, tim);
      };
    },

    updateBMap(lng, lat) {
      this.initMarker(lng,lat);
    },

    /* 根据地址解析位置信息 */
    async searchLocation(suc, fail) {
      if(this.loading){
        return;
      }

      this.loading = true;

      // 创建地址解析器实例         
      // sig: 'huhJ9uA6GWZJRriIzi0d9uFwbluNR0pZ',

      try{

        if(this.location != "" && !this.location.startsWith("上海")){
          this.location = "上海" + this.location;
        }

        let resp = await geoSearchApi(this.location);
        console.log("resp",resp)
        if(resp.status != 0){
          this.$message.error("未成功搜索地址！");
          this.loading = true;
          return;
        }

        this.$message.success("成功搜索地址！");
        let lng = resp.result.location.lng;
        let lat = resp.result.location.lat;

        this.addPointerAndFocus(lng, lat);

        this.lat = lat;
        this.lng = lng;


      } catch(e){
        this.$message.error(" 解析地址错误 ");
      } finally {
        this.loading = false;
      }

    },


    addPointerAndFocus(lng, lat) { 

      // https://lbs.qq.com/webApi/javascriptGL/glDoc/docIndexMap

      let position = new TMap.LatLng(lat,lng);
      console.log("addPointerAndFocus QMarker",QMarker)
      QMarker.setGeometries([])

      QMarker.add([{ //点标注数据数组
          "id": "1",
          "styleId": "marker",
          "position": position,
          "properties": {
              "title": "marker"
          }
      }])

      // this.mapGl = map;
      QMap.setCenter(position);


    },


    setAddresses(addresses){
      console.log("setAddresses",addresses)
    }

  },

  watch:{
    location(oldVal,newVal){
      // this.searchLocation(()=>{
      // },
      // ()=>{
      // });


      // let addressData = {
      //   lat: this.lat,
      //   lng: this.lng,
      //   location: this.location,
      // };
      // this.$emit("onAddressChanged", addressData);
    },

    lat(){
      let addressData = {
        lat: this.lat,
        lng: this.lng,
        location: this.location,
      };
      this.$emit("onAddressChanged", addressData);
    },

    lng(){
      let addressData = {
        lat: this.lat,
        lng: this.lng,
        location: this.location,
      };
      this.$emit("onAddressChanged", addressData);
    }
  },

  created() {

  },
};








// @ is an alias to /src
// declare var BMapGL: any;

</script>

<style scoped lang="scss">
.map__container {
  margin-left: 10px;
  width: 600px;
  height: 400px;
  position: relative;
  .dimension {
    position: absolute;
    right: 0;
    top: 0;
    transform: translateX(130%);
  }
}
.input__location {
  width: 400px;
}

#container {
  width: 100%;
  height: 100%;
}
</style>

